
  <fuse-card class="w-full flex flex-col p-4">    
      <div class="flex items-center justify-between mb-4">
        <div class="text-lg font-bold text-gray-800 flex items-baseline">
          Analyse en cours
        </div>
        <div class="text-sm text-gray-500">Traitement automatique</div>
      </div>

      <!-- If retry UI is active, show explanation and refresh button instead of progress bar -->
      <div *ngIf="!showRetryUi">
        <div class="w-full h-2 bg-gray-200 rounded overflow-hidden">
          <div
            class="h-full bg-teal-600 transition-all duration-300"
            [class.animate-pulse]="!determinate"
            [style.width]="determinate ? (boundedPercent + '%') : '0%'"></div>
        </div>

        <div class="mt-2 flex items-center justify-between text-sm text-gray-600">
          <div>
            {{ determinate ? ('Progression : ' + boundedPercent + '%') : 'Traitement en cours...' }}
          </div>
          <div class="font-medium text-gray-800">{{ boundedPercent }}%</div>
        </div>
      </div>

      <div *ngIf="showRetryUi" class="mt-3 p-4 bg-yellow-50 border border-yellow-200 rounded text-sm text-gray-800">
        <div class="mb-3">{{ retryExplanation }}</div>
        <div>
          <button class="px-3 py-2 bg-teal-600 text-white rounded" (click)="refreshPage()">Rafraîchir la page</button>
        </div>
      </div>

      <div class="mt-4 grid grid-cols-2 gap-3">
        <div class="p-3 bg-green-50 rounded flex items-center">
          <mat-icon class="text-green-600">check_circle</mat-icon>
          <div class="ml-3 text-sm font-medium">{{ statusMessage || 'Extraction des données' }}</div>
        </div>
        <div class="p-3 bg-white rounded border border-gray-200 flex items-center">
          <mat-icon class="text-gray-400 animate-spin">autorenew</mat-icon>
          <div class="ml-3 text-sm text-gray-500">Vérification de conformité</div>
        </div>
      </div>
  </fuse-card>